import {Injectable} from '@angular/core';
import {SharedValueService} from './shared-value.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import {Subject} from 'rxjs/Subject';
import {ModalSimpleComponent} from '../components/model-simple/modal-simple.component';
import {DialogParams, DialogResult} from '../models/dialog-param';
import {ModalEventComponent} from '../components/modal-event/modal-event.component';
import {ModalActionButtonsComponent} from '../components/modal-action-buttons/modal-action-buttons.component';
import {ModalUserComponent} from '../components/modal-user/modal-user.component';
import {ModalChangePasswordComponent} from '../components/modal-change-password/modal-change-password.component';
import {ModalProfileComponent} from '../components/modal-profile/modal-profile.component';
import {ModalCropperComponent} from '../components/modal-cropper/modal-cropper.component';
import {ModalRoomGroupComponent} from '../components/modal-room-group/modal-room-group.component';

@Injectable()
export class DialogService {
  private showLoader: boolean;

  private delaySec = 0;

  constructor(
    private sharedService: SharedValueService) {
  }

  setLoaderVisible(flag: boolean) {
    this.showLoader = flag;
  }

  isLoaderVisible() {
    return this.showLoader;
  }

  hideDialog(reOpenDialogName: string) {
    return Observable.create(observer => {
      if (reOpenDialogName) {
        (<any>$('#theModal')).modal('hide');
      }
      setTimeout(() => {
        observer.next();
        observer.complete();
      }, this.delaySec);
    });
  }

  showMessage(title: string, message: string, html: string,
              positiveButton: string, reportBtn: string, deleteBtn: string, negativeButton: string, size?: string) {
    return this.showModal(title, message, html, positiveButton, reportBtn, deleteBtn, null, negativeButton,
      ModalSimpleComponent, {}, size);
  }

  private showModal(title: string, message: string, html: string,
                    positiveButton: string, reportBtn: string, deleteBtn: string, checkInBtn: string, negativeButton: string,
                    component: any, extraParams: any, size: string) {
    const blank = new Subject<string>();
    const subject = new Subject<DialogResult>();

    const dialog = new DialogParams(
      component,
      title,
      message,
      html,
      positiveButton,
      reportBtn,
      deleteBtn,
      checkInBtn,
      negativeButton,
      subject,
      extraParams,
      size
    );
    this.sharedService.showModal.next(dialog);
    blank.next('');
    blank.complete();
    return subject;
  }

  showEventModal(title: string, positiveButton: string, reportBtn: string, deleteBtn: string, checkInBtn, negativeButton: string,
                       object: any) {
    return this.showModal(title, null, null, positiveButton, reportBtn, deleteBtn, checkInBtn, negativeButton,
      ModalEventComponent, {initialValue: object}, null);
  }

  showRoomGroupModal(title: string, positiveButton: string, negativeButton: string, object: any) {
    return this.showModal(title, null, null, positiveButton, null, null, null, negativeButton,
      ModalRoomGroupComponent, {initialValue: object}, null);
  }

  showUserModal(title: string, positiveButton: string, negativeButton: string, object: any) {
    return this.showModal(title, null, null, positiveButton, null, null, null, negativeButton,
      ModalUserComponent, {initialValue: object}, null);
  }

  showChangePasswordModal(title: string, object: any) {
    return this.showModal(title, null, null, 'Save', null, null, null, 'Close',
      ModalChangePasswordComponent, {initialValue: object}, null);
  }

  showUserProfileModal(title: string, object: any) {
    return this.showModal(title, null, null, null, null, null, null, 'Close',
      ModalProfileComponent, {initialValue: object}, 'modal-lg');
  }

  showCropperDialog(title: string, object: any, reOpenDialogName?: string, params?: any) {
    const subject = new Subject();
    this.hideDialog(reOpenDialogName).mergeMap((res) => {
      return this.showModal(title, null,  null, 'Ok', null, null, null, 'Cancel',
        ModalCropperComponent, { initialValue: object }, null);
    }).delay(this.delaySec)
      .mergeMap((res: DialogResult) => {
      return Observable.create(observer => {
        if (res.isOk()) {
          observer.next(res.payload);
        } else {
          if (reOpenDialogName) {
            this[reOpenDialogName].apply(this, params);
          }
          observer.complete();
        }
      });
    }).delay(this.delaySec).subscribe((res) => {
      if (reOpenDialogName) {
        this[reOpenDialogName].apply(this, params);
      }
      subject.next(res);
      subject.complete();
    });
    return subject;
  }


  showDeleteEventDialog(model?: any, reOpenDialogName?: string, params?: any) {
    const subject = new Subject();
    this.hideDialog(reOpenDialogName).mergeMap((res) => {
      if (model.repeat_rule || model.repeat_parent_id) {
        const obj = {message: 'Choose the type delete?'};
        return this.showModal('Delete recurring event', null, null, 'Delete', null, null, null,
          'Cancel', ModalActionButtonsComponent, {initialValue: obj}, null);
      } else {
        const html = `<div class="col-md-12">
                        <h5 class="text-center d-block">Are you sure delete this event?</h5>
                      </div>`;
        return this.showMessage( 'Delete event', null, html, 'Delete', null, null,
          'Cancel');
      }
    }).delay(this.delaySec)
      .subscribe((res: DialogResult) => {
        subject.next(res);
        subject.complete();
      });
    return subject;
  }

  showUpdateEventDialog(model?: any, reOpenDialogName?: string, params?: any) {
    const subject = new Subject();
    this.hideDialog(reOpenDialogName).mergeMap((res) => {
      if (model.repeat_rule) {
        const obj = {message: 'Choose the type edit?', isEdit: true};
        return this.showModal('Edit recurring event', null, null, 'Edit', null, null, null,
          'Cancel', ModalActionButtonsComponent, {initialValue: obj}, null);
      } else {
        const html = `<div class="col-md-12">
                        <h5 class="text-center d-block">Are you sure edit this event?</h5>
                      </div>`;
        return this.showMessage( 'Edit event', null, html, 'Edit', null, null,
          'Cancel');
      }
    }).delay(this.delaySec)
      .subscribe((res: DialogResult) => {
        subject.next(res);
        subject.complete();
      });
    return subject;
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/dialog.service.ts